/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
    // Add custom code below this line
    if (!customElements.get('pickup-availability-notification')) {
        customElements.define('pickup-availability-notification', class PickupAvailability extends HTMLElement {
            constructor() {
                super();

                this.fetchAvailability(this.dataset.variantId);
            }

            fetchAvailability(variantId) {
                let rootUrl = this.dataset.rootUrl;
                if (!rootUrl.endsWith("/")) {
                    rootUrl = rootUrl + "/";
                }
                const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability-notification`;

                fetch(variantSectionUrl)
                    .then(response => {
                        return response.text()
                    }).then((text) => {
                    const sectionInnerHTML = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('.shopify-section');
                    this.renderPreview(sectionInnerHTML);
                })
                    .catch(e => {
                        console.log('error')
                    });
            }


            renderPreview(sectionInnerHTML) {
                this.setAttribute('available', '');
                this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-notification').outerHTML;
            }
        });

        document.addEventListener('theme:variant:change', function({ detail : { variant } }) {
            const pickUpAvailabilityNotification = document.querySelector('pickup-availability-notification');
            document.getElementById('klaviyo-variant').value = variant.id;
            var messageElement = document.getElementById('klaviyo-message');
            messageElement.textContent = "";
            if (!pickUpAvailabilityNotification) return;

            if (variant.available) {
                pickUpAvailabilityNotification.fetchAvailability(variant.id);
                document.querySelector("#klaviyo-back-in-stock").style.display = "none";
                document.querySelector(".product__submit__item--inline").classList.remove('sold');
                document.querySelector(" .product__submit__item--inline .select-popout").style.display = "block";
                document.querySelector("button.btn[data-add-to-cart]").style.display = "block";
            } else {
                pickUpAvailabilityNotification.removeAttribute('available');
                document.querySelector(".product__submit__item--inline").classList.add('sold');
                document.querySelector("#klaviyo-back-in-stock").style.display = "flex";
                document.querySelector(" .product__submit__item--inline .select-popout").style.display = "none";
                document.querySelector("button.btn[data-add-to-cart]").style.display = "none";
            }
        });
    }

    document.addEventListener('theme:drawer:open', (event) => {
        const headerSearchForm = document.querySelector('.header__mobile header-search-form');
        const isHeaderSticky = !!document.querySelector('[data-header-sticky]')

        if (!headerSearchForm) return;

        const rect = headerSearchForm.getBoundingClientRect();
        const scrollY = isHeaderSticky ? 0 : window.scrollY;

        event?.target?.style?.setProperty("--offset", `${rect.top + scrollY + headerSearchForm.offsetHeight}px`);
    });
    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();
